// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"484de8db","789":"912bd565","820":"ab773547","837":"ce9b02e1"}[chunkId] + ".chunk.js";
};